module.exports = __webpack_public_path__ + "static/media/Managers.ee538935.svg";